import { Suspense, lazy, useContext } from 'react';

import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

import { observer } from 'mobx-react-lite';

import {
  AGENT_NOT_FOUND,
  AUTH,
  CANDIDATE_AUTH,
  OTP,
  PASSWORD_RECOVERY,
  PageLoader,
  useAxiosInterceptors,
  useScrollToTop,
  useStores,
} from '@shared/index';

import { UserContext } from './contexts/user-context';

import './i18n/config';

const Routing = lazy(() => import('../pages'));
const AuthPage = lazy(() => import('@pages/auth'));
const PasswordRecoveryPage = lazy(() => import('@pages/password-recovery'));
const OtpPage = lazy(() => import('@pages/otp'));
const AgentNotFoundPage = lazy(() => import('@pages/agent-not-found'));

// Страницы флоу кандидата
const CandidateAuthPage = lazy(() => import('@pages/candidate-auth'));

export const AppContent = observer(() => {
  const { isAuthenticated } = useContext(UserContext);
  const {
    MainStore: {
      agentUserStore: { agent, confirmToken },
    },
  } = useStores();
  useAxiosInterceptors();
  useScrollToTop();

  const { pathname } = useLocation();

  return (
    <Suspense fallback={<PageLoader />}>
      {isAuthenticated ? (
        <Routing />
      ) : (
        <Routes>
          <Route
            path={AUTH}
            element={<AuthPage />}
          />
          <Route
            path={PASSWORD_RECOVERY}
            element={<PasswordRecoveryPage />}
          />
          <Route
            path={AGENT_NOT_FOUND}
            element={<AgentNotFoundPage />}
          />
          <Route
            path={CANDIDATE_AUTH}
            element={<CandidateAuthPage />}
          />
          {!!agent?.phone && confirmToken && (
            <Route
              path={OTP}
              element={<OtpPage />}
            />
          )}
          <Route
            path='*'
            element={
              <Navigate
                state={{ redirectTo: pathname }}
                to={AUTH}
              />
            }
          />
        </Routes>
      )}
    </Suspense>
  );
});
